import { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useAppNavigate from "../../components/router/use-app-navigate";
import AuthContext from "../../components/auth-context";
import Form from "../../components/inputs/form";
import Textarea from "../../components/inputs/textarea";
import Textbox from "../../components/inputs/textbox";
import Selectline from "./select-line";
import Textfield from "../../components/inputs/textfield";
import CustomerApi from "../../api/customer";
import FileApi from "../../api/file";
import { useTranslation } from "react-i18next";
import VerifyNumber from "../../components/signup/verify-number";
import NewRequestResendCodeApi from "../../api/newRequest-resendCode";
import { localizeNumbers } from "../../functions";
import { Link } from "react-router-dom";
import CustomerInfo from "../../components/signup/customer-info";

interface NgnForm {
  agentCode: string;
  installAddress: string;
  channelsCount: string;
}

function Ngn() {
  const [agentCode, setAgentCode] = useState("");
  const [channelsCount, setChannelsCount] = useState("");
  const { register, handleSubmit } = useForm<NgnForm>();
  const navigate = useAppNavigate();
  const [number, setNumber] = useState("");
  const [isCompany, setIsCompany] = useState(false);
  const { t } = useTranslation(undefined, { keyPrefix: "Request.Ngn" });
  const [isVerifying, setIsVerifying] = useState(false);
  const [installAddress, setInstallAddress] = useState("");
  const [toggle, setToggle] = useState(true);
  const context = useContext(AuthContext);
  const { customerInfo } = context;

  useEffect(() => {
    const getCustomerData = () => {
      const customerApi = new CustomerApi(context);
      customerApi
        .get()
        .then((data) => {
          setIsCompany(data.company != null);
          console.log("customerInfo", data);
        })
        .catch(() => {});
    };

    getCustomerData();
  }, [context]);

  const onSubmit: (data: any) => Promise<string> = async ({
    agentCode,
    installAddress,
    channelsCount,
  }) => {
    setAgentCode(agentCode);
    setInstallAddress(installAddress);
    setChannelsCount(channelsCount);

    const newRequestApi = new NewRequestResendCodeApi(context);
    newRequestApi.get("NGN").then((response) => {
      if (response.errorMessage === null) {
        setIsVerifying(true);
        return response.errorMessage;
      }
    });
    return "";
  };

  const onVerifyNumberSubmit = async () => {
    const fileApi = new FileApi(context);
    if (number !== undefined) {
      fileApi
        .post(40, number, "", agentCode, "", installAddress, channelsCount)
        .then((response) => {
          context.setActiveFileId(response.id);
          if (response && response.id) {
            navigate("/purchase/service");
          } else {
            return response.errorMessage || "خطایی رخ داده است.";
          }
          return "";
        });
    }
  };

  return number === "" ? (
    <Selectline onSelectLine={setNumber} handleClick={() => {}} />
  ) : (
    <>
      {!isVerifying ? (
        <Form submit={onSubmit} handleSubmit={handleSubmit}>
          <h3 className="lead-title pt-2">{t("Title")}</h3>ّ
          <Textfield label="شماره" value={number} />
          {isCompany && (
            <Textbox
              {...register("channelsCount")}
              label="تعداد کانال"
              onChange={(e) => {
                setChannelsCount(e.target.value);
              }}
              defaultValue={channelsCount}
              type="number"
            />
          )}
          <Textbox
            {...register("agentCode")}
            label="کد نمایندگی"
            helpNote="در صورتی که توسط یک نماینده جهت ثبت نام معرفی شده اید."
            onChange={(e) => {
              setAgentCode(e.target.value);
            }}
            defaultValue={agentCode}
            type="number"
          />
          <Textarea
            {...register("installAddress")}
            label="آدرس نصب"
            helpNote="در صورت نیاز به نصب مودم توسط کارشناس شرکت، تعیین آدرس مراجعه مورد نیاز است."
            onChange={(e) => {
              setInstallAddress(e.target.value);
            }}
          />
          <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row  gap-4 justify-between">
            <div className="rule-section flex algin-center items-center gap-2">
              <input
                id="role-checkbox"
                type="checkbox"
                tabIndex={19}
                onClick={() => setToggle(!toggle)}
              />
              <label className="role-checkbox-label" htmlFor="role-checkbox">
                <p className="w-50">
                  {t("I had read and accept the contract", {
                    name: `${customerInfo?.firstName ?? ""} ${
                      customerInfo?.lastName ?? ""
                    }`,
                    nationalCode: localizeNumbers(customerInfo?.nationalCode!),
                    service: "Td-Lte",
                    username: localizeNumbers(customerInfo?.cellPhone!),
                  })}
                  <small>
                    <Link
                      to="https://internet.sepanta.com/docs/NgnContract.pdf"
                      className="btn-show-role font-bold"
                    >
                      ({t("Read contract")})
                    </Link>
                  </small>
                </p>
              </label>
            </div>
          </div>
          <div className="rule-section flex algin-center items-center gap-2">
            <button
              disabled={toggle}
              className="signup-btn p-5 flex"
              tabIndex={20}
            >
              {t("Accept & Continue")}
              <span className="sepanta-icon-left-long-arrow"></span>
            </button>
          </div>
        </Form>
      ) : (
        <VerifyNumber
          username={
            customerInfo?.company != null
              ? customerInfo?.company?.nationalIdentity.toString()
              : customerInfo?.cellPhone!
          }
          cellPhone={customerInfo?.cellPhone!}
          onSubmit={onVerifyNumberSubmit}
          handleAlert={(msg) => alert(msg)}
          alert={false}
          serviceType={"ADSL"}
        />
      )}
    </>
  );
}

export default Ngn;
